import { Icon } from "@iconify/react";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/buttons/Button";
import Translations from "../../lang/en/pages.json";
import Minimal from "../../layouts/Minimal";
import WelcomeBG from "../../assets/images/welcome-bg.png";

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const handleSubmit = () => navigate("/cases");

  return (
    <Minimal
      sx={{
        backgroundImage: `url(${WelcomeBG})`,
        backgroundSize: "cover",
        backgroundPosition: `${window.innerWidth * -0.4}px ${window.innerHeight * 0.4}px`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Stack
        sx={{ width: { xs: "100%", sm: "80%" } }}
        spacing={6}
        textAlign={"center"}
        alignItems={"center"}
      >
        <Stack spacing={1} alignItems={"center"}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Typography
              sx={{ color: "#7C4DFF" }}
              fontWeight={"medium"}
              variant="h4"
            >
              {Translations.pages.welcome_page.title}
            </Typography>

            <Typography
              sx={{ color: "#266A4A" }}
              fontWeight={"bold"}
              variant="h4"
            >
              {Translations.pages.welcome_page.title2}
            </Typography>
          </Stack>
          <Typography
            color={"textPrimary"}
            fontWeight={"light"}
            variant="caption"
          >
            {Translations.pages.welcome_page.description}
          </Typography>
        </Stack>
        <Button width={"30%"} variant="green" onClick={handleSubmit}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            {/*<Icon icon="mdi:court-hammer" width="24" height="24" />*/}
            <Box>{Translations.pages.welcome_page.button}</Box>
          </Stack>
        </Button>
      </Stack>
    </Minimal>
  );
};

export default Welcome;
